
define('jst!presence/presence_bar/_typer',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<span class="text-bold"><%= content %></span>');
 });

